"use strict";
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _optionalChain(ops) {
    var lastAccessLHS = undefined;
    var value = ops[0];
    var i = 1;
    while(i < ops.length){
        var op = ops[i];
        var fn = ops[i + 1];
        i += 2;
        if ((op === "optionalAccess" || op === "optionalCall") && value == null) {
            return undefined;
        }
        if (op === "access" || op === "optionalAccess") {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === "call" || op === "optionalCall") {
            var _value;
            value = fn(function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                return (_value = value).call.apply(_value, [
                    lastAccessLHS
                ].concat(_to_consumable_array(args)));
            });
            lastAccessLHS = undefined;
        }
    }
    return value;
}
var _chunk7VBK3YDPjs = require("./chunk-7VBK3YDP.js");
var _chunkDSPWNYKZjs = require("./chunk-DSPWNYKZ.js");
var _chunkV767VWABjs = require("./chunk-V767VWAB.js");
var _chunkYULSKELGjs = require("./chunk-YULSKELG.js");
var _chunkL6B4ALZ3js = require("./chunk-L6B4ALZ3.js");
var _chunk3KNDPG6Yjs = require("./chunk-3KNDPG6Y.js");
// src/services/auth.ts
var _qss = require("qss");
var _jsbase64 = require("js-base64");
var _randomizedstring = require("randomized-string");
var _ciamsdk = require("@inner-source/ciam-sdk");
var PcidAuth = /*#__PURE__*/ function() {
    function PcidAuth(config) {
        _class_call_check(this, PcidAuth);
        /** Key to store nonce in session storage */ this.nonceKey = "pcidNonceKey";
        /** Key to store csrf in session storage */ this.csrf = "csrfKey";
        /** Key to store code verifier in session storage
     * Code verifier is used to protect against man in the middle attacks for
     * applications that don't have a server side to protect secrets.
     */ this.codeVerifierKey = "pcidCodeVerifierKey";
        this.requestBuilder = new (0, _chunk7VBK3YDPjs.RequestBuilder)();
        this.correlationId = _randomizedstring.generate.call(void 0, 10);
        config.idcsBaseUrl = _chunkL6B4ALZ3js.getAudienceUrl.call(void 0, config.environment);
        config.ciamApiUrl = _chunkL6B4ALZ3js.getBaseUrl.call(void 0, config.environment);
        config.managementUrl = _chunkL6B4ALZ3js.getMyAccountUrl.call(void 0, config.environment);
        this.config = config;
    }
    _create_class(PcidAuth, [
        {
            key: "basicAuth",
            value: function basicAuth() {
                var token = _jsbase64.Base64.encode("".concat(this.config.clientId, ":").concat(this.config.clientSecret));
                return "Basic ".concat(token);
            }
        },
        {
            key: "clearNonce",
            value: function clearNonce() {
                sessionStorage.removeItem(this.nonceKey);
            }
        },
        {
            key: "setNonce",
            value: function setNonce(nonce) {
                sessionStorage.setItem(this.nonceKey, nonce);
            }
        },
        {
            key: "getNonce",
            value: function getNonce() {
                var ciamAuthNonce = sessionStorage.getItem(this.nonceKey);
                if (ciamAuthNonce === null) {
                    void this.log("ERROR" /* ERROR */ , "Nonce not found in sessionStorage.");
                    throw new Error("Nonce not found in sessionStorage.");
                }
                return ciamAuthNonce;
            }
        },
        {
            key: "clearCsrf",
            value: function clearCsrf() {
                sessionStorage.removeItem(this.csrf);
            }
        },
        {
            key: "setCsrf",
            value: function setCsrf(csrf) {
                sessionStorage.setItem(this.csrf, csrf);
            }
        },
        {
            key: "setLanguage",
            value: function setLanguage(language) {
                this.config.stateParams.language = language;
            }
        },
        {
            key: "setRedirectUrl",
            value: function setRedirectUrl(redirectUrl) {
                this.config.redirectUrl = redirectUrl;
            }
        },
        {
            key: "getCsrf",
            value: function getCsrf() {
                var ciamAuthCsrf = sessionStorage.getItem(this.csrf);
                if (ciamAuthCsrf === null) {
                    throw new (0, _chunkV767VWABjs.CsrfNotFoundError)("Csrf not found in sessionStorage.");
                }
                return ciamAuthCsrf;
            }
        },
        {
            key: "clearCodeVerifier",
            value: function clearCodeVerifier() {
                sessionStorage.removeItem(this.codeVerifierKey);
            }
        },
        {
            key: "setCodeVerifier",
            value: function setCodeVerifier(codeVerifier) {
                sessionStorage.setItem(this.codeVerifierKey, codeVerifier);
            }
        },
        {
            key: "getCodeVerifier",
            value: function getCodeVerifier() {
                var authCodeVerifierKey = sessionStorage.getItem(this.codeVerifierKey);
                this.clearCodeVerifier();
                return authCodeVerifierKey;
            }
        },
        {
            key: "generateTokenUrl",
            value: function generateTokenUrl() {
                return "".concat(_chunkL6B4ALZ3js.getLoginUrl.call(void 0, this.config.environment), "/oauth2/v1/token" /* ServerTokenPath */ );
            }
        },
        {
            /** Returns client Basic auth header and 'Content-Type' headers */ key: "getHeaders",
            value: function getHeaders() {
                var headers = {};
                headers.Authorization = this.basicAuth();
                headers["Content-Type"] = "application/x-www-form-urlencoded;charset=UTF-8";
                return headers;
            }
        },
        {
            key: "getAuthTokenFromCode",
            value: function getAuthTokenFromCode(data) {
                var body = _qss.encode.call(void 0, {
                    grant_type: "authorization_code" /* GrantType */ ,
                    code: data.queryArgs.get("code" /* Code */ ),
                    redirect_uri: this.config.redirectUrl,
                    code_verifier: data.codeVerifier,
                    client_id: this.config.clientId
                });
                return this.fetchTokens(body);
            }
        },
        {
            key: "fetchTokens",
            value: function fetchTokens(data) {
                var _this = this;
                return this.requestBuilder.post(this.generateTokenUrl(), data, _define_property({}, "headers" /* Headers */ , this.getHeaders())).then(function(tokenResponse) {
                    if (_this.config.addOfflineAccessToScopes) {
                        _this.getFetchTokenResponseWithRT(tokenResponse);
                    } else {
                        _this.getFetchTokenResponseWithoutRT(tokenResponse);
                    }
                    return tokenResponse;
                }).then(function(tokenResponse) {
                    if (_this.config.pkceFlow) {
                        _this.validateNonceHelper(tokenResponse);
                    }
                    return tokenResponse;
                }).then(function(tokenResponse) {
                    return _this.cleanUp(tokenResponse);
                }).catch(function(error) {
                    void _this.log("ERROR" /* ERROR */ , "Error while fetching tokens: ".concat(error));
                    throw error;
                });
            }
        },
        {
            key: "getFetchTokenResponseWithRT",
            value: function getFetchTokenResponseWithRT(data) {
                return data;
            }
        },
        {
            key: "getFetchTokenResponseWithoutRT",
            value: function getFetchTokenResponseWithoutRT(data) {
                return data;
            }
        },
        {
            key: "validateNonceHelper",
            value: function validateNonceHelper(data) {
                return data;
            }
        },
        {
            key: "cleanUp",
            value: function cleanUp(tokenResponse) {
                this.clearNonce();
                this.clearCodeVerifier();
                this.clearCsrf();
                return tokenResponse;
            }
        },
        {
            key: "refreshAccessToken",
            value: /**
   * Refreshes the access token using refresh token
   *
   * sting refreshToken - The user's refresh token.
   * @returns Promise<PostFetchTokenResponseType> - A new access token and a refresh token.
   */ function refreshAccessToken(refreshToken) {
                var _this = this;
                return _async_to_generator(function() {
                    var body, tokens, validateJwt;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                body = {
                                    grant_type: "refresh_token",
                                    refresh_token: refreshToken
                                };
                                return [
                                    4,
                                    _this.fetchRefreshTokens(body)
                                ];
                            case 1:
                                tokens = _state.sent();
                                return [
                                    4,
                                    _this.validateToken(tokens.access_token)
                                ];
                            case 2:
                                validateJwt = _state.sent();
                                if (!validateJwt) {
                                    void _this.log("ERROR" /* ERROR */ , "Error while validating refreshed access token");
                                    throw new (0, _chunkV767VWABjs.JwtValidationError)(_chunkYULSKELGjs.errorMessages.JWT_VALIDATION_FAILED);
                                }
                                return [
                                    2,
                                    tokens
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "fetchRefreshTokens",
            value: function fetchRefreshTokens(data) {
                var _this = this;
                return this.requestBuilder.post(this.generateTokenUrl(), data, _define_property({}, "headers" /* Headers */ , this.getHeaders())).then(function(tokenResponse) {
                    return _this.getFetchRefreshTokenResponse(tokenResponse);
                }).catch(function(error) {
                    void _this.log("ERROR" /* ERROR */ , "Error while refreshing access token: ".concat(error));
                    throw error;
                });
            }
        },
        {
            key: "getFetchRefreshTokenResponse",
            value: function getFetchRefreshTokenResponse(data) {
                void this.log("INFO" /* INFO */ , "Access Token refreshed");
                return data;
            }
        },
        {
            key: "getQueryArgs",
            value: function getQueryArgs(search) {
                return search;
            }
        },
        {
            key: "handleSignIn",
            value: /**
   * Handles the sign-in process asynchronously.
   *
   * @returns Promise<boolean> - A Promise that resolves to a boolean indicating the success of the sign-in process.
   * @throws JwtValidationError - error if AT returned is invalid.
   */ function handleSignIn(code, state) {
                var _this = this;
                return _async_to_generator(function() {
                    var search, queryArgs, tokens, codeVerifier, validateJwt, error;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                search = new URLSearchParams();
                                search.append("code", code);
                                search.append("state", state);
                                void _this.log("INFO" /* INFO */ , "Handle sign in url params: ".concat(search));
                                if (!(code && state)) return [
                                    3,
                                    8
                                ];
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    7,
                                    ,
                                    8
                                ]);
                                queryArgs = _this.getQueryArgs(search);
                                if (!_this.config.pkceFlow) return [
                                    3,
                                    3
                                ];
                                codeVerifier = _this.getCodeVerifier();
                                return [
                                    4,
                                    _this.getAuthTokenFromCode({
                                        queryArgs: queryArgs,
                                        codeVerifier: codeVerifier
                                    })
                                ];
                            case 2:
                                tokens = _state.sent();
                                return [
                                    3,
                                    5
                                ];
                            case 3:
                                return [
                                    4,
                                    _this.getAuthTokenFromCode({
                                        queryArgs: queryArgs
                                    })
                                ];
                            case 4:
                                tokens = _state.sent();
                                _state.label = 5;
                            case 5:
                                return [
                                    4,
                                    _this.validateToken(tokens.access_token)
                                ];
                            case 6:
                                validateJwt = _state.sent();
                                if (!validateJwt) {
                                    void _this.log("ERROR" /* ERROR */ , "Error while validating access token");
                                    throw new (0, _chunkV767VWABjs.JwtValidationError)(_chunkYULSKELGjs.errorMessages.JWT_VALIDATION_FAILED);
                                }
                                void _this.log("INFO" /* INFO */ , "Tokens returned.");
                                return [
                                    2,
                                    tokens
                                ];
                            case 7:
                                error = _state.sent();
                                if (!(_instanceof(error, _chunkV767VWABjs.CsrfNotFoundError) || _instanceof(error, _chunkV767VWABjs.AuthCodeNotFoundError))) {
                                    void _this.log("ERROR" /* ERROR */ , "Error while fetching tokens: ".concat(error));
                                }
                                throw error;
                            case 8:
                                return [
                                    2,
                                    null
                                ];
                        }
                    });
                })();
            }
        },
        {
            /**
   * Generates an object for use in the authentication process.
   *
   * @returns Object - The generated authentication object.
   */ key: "generateStateObj",
            value: function generateStateObj() {
                var obj = {
                    csrf: _ciamsdk.generateRandomString.call(void 0),
                    relyingParty: this.config.stateParams.relyingParty,
                    intent: this.config.stateParams.intent,
                    language: this.config.stateParams.language,
                    scope: this.generateScope(),
                    keepMeSignedIn: this.config.keepMeSignedIn,
                    showIsThisYouPrompt: this.config.showIsThisYouPrompt,
                    // clientId is required to store values in local storage
                    clientId: this.config.clientId,
                    customProps: this.config.stateParams.customProps,
                    utm_source: _optionalChain([
                        this,
                        "access",
                        function(_) {
                            return _.config;
                        },
                        "access",
                        function(_2) {
                            return _2.utm;
                        },
                        "optionalAccess",
                        function(_3) {
                            return _3.utm_source;
                        }
                    ]),
                    utm_medium: _optionalChain([
                        this,
                        "access",
                        function(_4) {
                            return _4.config;
                        },
                        "access",
                        function(_5) {
                            return _5.utm;
                        },
                        "optionalAccess",
                        function(_6) {
                            return _6.utm_medium;
                        }
                    ]),
                    utm_campaign: _optionalChain([
                        this,
                        "access",
                        function(_7) {
                            return _7.config;
                        },
                        "access",
                        function(_8) {
                            return _8.utm;
                        },
                        "optionalAccess",
                        function(_9) {
                            return _9.utm_campaign;
                        }
                    ]),
                    utm_term: _optionalChain([
                        this,
                        "access",
                        function(_10) {
                            return _10.config;
                        },
                        "access",
                        function(_11) {
                            return _11.utm;
                        },
                        "optionalAccess",
                        function(_12) {
                            return _12.utm_term;
                        }
                    ]),
                    utm_content: _optionalChain([
                        this,
                        "access",
                        function(_13) {
                            return _13.config;
                        },
                        "access",
                        function(_14) {
                            return _14.utm;
                        },
                        "optionalAccess",
                        function(_15) {
                            return _15.utm_content;
                        }
                    ])
                };
                this.setCsrf(obj.csrf);
                return Buffer.from(JSON.stringify(obj)).toString("base64");
            }
        },
        {
            /**
   * Generates the scope for the authentication process.
   *
   * @returns string - The generated scope string.
   */ key: "generateScope",
            value: function generateScope() {
                var offlineAccess = this.config.addOfflineAccessToScopes ? " offline_access" : "";
                return "openid ".concat(this.config.scope).concat(offlineAccess);
            }
        },
        {
            key: "pcidCreateAccountFunction",
            value: /**
   * Generates a login URL for the authentication process.
   *
   * @returns string - The generated PCID login URL with all necessary stateParams and redirects to create-account page.
   */ function pcidCreateAccountFunction() {
                var _this = this;
                return _async_to_generator(function() {
                    return _ts_generator(this, function(_state) {
                        _this.config.stateParams.intent = "register";
                        return [
                            2,
                            _this.generateLoginUrl()
                        ];
                    });
                })();
            }
        },
        {
            key: "pcidLoginFunction",
            value: /**
   * Generates a login URL for the authentication process.
   *
   * @returns string - The generated PCID login URL with all necessary stateParams and redirects to login page.
   */ function pcidLoginFunction() {
                var _this = this;
                return _async_to_generator(function() {
                    return _ts_generator(this, function(_state) {
                        _this.config.stateParams.intent = "login";
                        return [
                            2,
                            _this.generateLoginUrl()
                        ];
                    });
                })();
            }
        },
        {
            key: "generateLoginUrl",
            value: /**
   * Generates a login URL for the authentication process.
   *
   * @returns string - The generated PCID login URL with all necessary stateParams.
   */ function generateLoginUrl() {
                var _this = this;
                return _async_to_generator(function() {
                    var stateObj, urlArgs, codeChallenge;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                stateObj = _this.generateStateObj();
                                if (!_this.config.pkceFlow) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this.getCodeChallenge()
                                ];
                            case 1:
                                codeChallenge = _state.sent();
                                _this.generateNonce();
                                urlArgs = decodeURIComponent(_this.generateUrlArgs(_this.getNonce(), stateObj, codeChallenge));
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                urlArgs = decodeURIComponent(_this.generateUrlArgs("", stateObj, ""));
                                _state.label = 3;
                            case 3:
                                return [
                                    2,
                                    _this.generateAuthenticatedLoginUrl(urlArgs)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getCodeChallenge",
            value: function getCodeChallenge() {
                var _this = this;
                return _async_to_generator(function() {
                    var codeChallenge;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _ciamsdk.createCodeChallenge.call(void 0, _this.generateCodeVerifier())
                                ];
                            case 1:
                                codeChallenge = _state.sent();
                                return [
                                    2,
                                    codeChallenge
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "generateCodeVerifier",
            value: function generateCodeVerifier() {
                var codeVerifier = _ciamsdk.createCodeVerifier.call(void 0);
                this.setCodeVerifier(codeVerifier);
                return codeVerifier;
            }
        },
        {
            key: "generateNonce",
            value: function generateNonce() {
                var nonce = _ciamsdk.generateRandomString.call(void 0);
                this.setNonce(nonce);
            }
        },
        {
            /**
   * sets custom props
   * @param prop- new custom property to be added.
   */ key: "setCustomProps",
            value: function setCustomProps(prop) {
                var existingProps = this.config.stateParams.customProps;
                var mergedProps = _object_spread({}, existingProps, prop);
                this.config.stateParams.customProps = mergedProps;
            }
        },
        {
            /**
   * Generates URL arguments for the authentication process.
   *
   *  string nonce - The nonce value for security.
   *  string stateObj - The authentication state object.
   *  Promise<string> codeChallenge - The promise for the code challenge.
   * @returns Object - The generated URL arguments.
   */ key: "generateUrlArgs",
            value: function generateUrlArgs(nonce, stateObj, codeChallenge) {
                if (!this.config.pkceFlow) {
                    return _qss.encode.call(void 0, {
                        client_id: this.config.clientId,
                        response_type: "code" /* Code */ ,
                        redirect_uri: this.config.redirectUrl,
                        scope: this.generateScope(),
                        state: stateObj
                    });
                }
                return _qss.encode.call(void 0, {
                    client_id: this.config.clientId,
                    response_type: "code" /* Code */ ,
                    redirect_uri: this.config.redirectUrl,
                    code_challenge: codeChallenge,
                    code_challenge_method: "S256" /* CodeChallengeMethod */ ,
                    scope: this.generateScope(),
                    state: stateObj,
                    nonce: nonce
                });
            }
        },
        {
            /**
   * Generates an authenticated login URL based on the provided URL arguments.
   * string urlArgs - The URL arguments for the authentication process.
   * @returns string - The authenticated login URL.
   */ key: "generateAuthenticatedLoginUrl",
            value: function generateAuthenticatedLoginUrl(urlArgs) {
                var urlPath = "".concat(_chunkL6B4ALZ3js.getLoginUrl.call(void 0, this.config.environment), "/oauth2/v1/authorize" /* AuthorizePath */ );
                var authenticatedUrl = "".concat(urlPath, "?").concat(urlArgs);
                void this.log("INFO" /* INFO */ , "Login url generated: ".concat(authenticatedUrl));
                return authenticatedUrl;
            }
        },
        {
            key: "validateToken",
            value: /**
   * Validates AT issued by IDCS.
   * @param accessToken - access tokens issues by Oracle Idcs.
   */ function validateToken(accessToken) {
                var _this = this;
                return _async_to_generator(function() {
                    var jwkUrl, validJwt;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                jwkUrl = "".concat(_chunkL6B4ALZ3js.getLoginUrl.call(void 0, _this.config.environment), "/admin/v1/SigningCert/jwk");
                                return [
                                    4,
                                    _ciamsdk.verifyJwt.call(void 0, jwkUrl, accessToken).catch(function(error) {
                                        void _this.log("ERROR" /* ERROR */ , "Error while jwk validation call ".concat(error));
                                    })
                                ];
                            case 1:
                                validJwt = _state.sent();
                                return [
                                    2,
                                    validJwt
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "log",
            value: /**
   * Prints log in the client-logging service.
   * @param logLevel - logging level INFO ERROR etc.
   * @param logMsg - log messages.
   * */ /* eslint-disable @typescript-eslint/require-await -- Logs must be Async to prevent blocking */ function log(logLevel, logMsg) {
                var _this = this;
                return _async_to_generator(function() {
                    var logRequest, loggingUrl;
                    return _ts_generator(this, function(_state) {
                        try {
                            logRequest = {
                                payload: logMsg,
                                "logging-level": logLevel
                            };
                            loggingUrl = "".concat(_chunkL6B4ALZ3js.getApiUrl.call(void 0, _this.config.environment), "/v1/client/logs");
                            fetch(loggingUrl, {
                                method: "POST",
                                headers: {
                                    "Content-Type": "application/json",
                                    "relying-party": _this.config.stateParams.relyingParty,
                                    "x-forwarded-for": _optionalChain([
                                        _this,
                                        "access",
                                        function(_16) {
                                            return _16.config;
                                        },
                                        "access",
                                        function(_17) {
                                            return _17.logDetails;
                                        },
                                        "optionalAccess",
                                        function(_18) {
                                            return _18.sourceIps;
                                        }
                                    ]) || "",
                                    source: _optionalChain([
                                        _this,
                                        "access",
                                        function(_19) {
                                            return _19.config;
                                        },
                                        "access",
                                        function(_20) {
                                            return _20.logDetails;
                                        },
                                        "optionalAccess",
                                        function(_21) {
                                            return _21.source;
                                        }
                                    ]) || "WEB",
                                    "user-agent": _optionalChain([
                                        _this,
                                        "access",
                                        function(_22) {
                                            return _22.config;
                                        },
                                        "access",
                                        function(_23) {
                                            return _23.logDetails;
                                        },
                                        "optionalAccess",
                                        function(_24) {
                                            return _24.userAgent;
                                        }
                                    ]) || "",
                                    "x-correlation-id": _this.correlationId
                                },
                                body: JSON.stringify(logRequest)
                            }).catch(function(_error) {});
                        } catch (error) {
                            void _this.log("ERROR" /* ERROR */ , "Error creating a log: ".concat(error));
                        }
                        return [
                            2
                        ];
                    });
                })();
            }
        }
    ]);
    return PcidAuth;
}();
_chunk3KNDPG6Yjs.__decorateClass.call(void 0, [
    _chunkDSPWNYKZjs.validateAuthCodeVerifierKey
], PcidAuth.prototype, "getCodeVerifier", 1);
_chunk3KNDPG6Yjs.__decorateClass.call(void 0, [
    _chunkDSPWNYKZjs.validateResponseKeys
], PcidAuth.prototype, "getFetchTokenResponseWithRT", 1);
_chunk3KNDPG6Yjs.__decorateClass.call(void 0, [
    _chunkDSPWNYKZjs.validateResponseKeysWithoutRT
], PcidAuth.prototype, "getFetchTokenResponseWithoutRT", 1);
_chunk3KNDPG6Yjs.__decorateClass.call(void 0, [
    _chunkDSPWNYKZjs.validateNonce
], PcidAuth.prototype, "validateNonceHelper", 1);
_chunk3KNDPG6Yjs.__decorateClass.call(void 0, [
    _chunkDSPWNYKZjs.validateResponseKeys
], PcidAuth.prototype, "getFetchRefreshTokenResponse", 1);
_chunk3KNDPG6Yjs.__decorateClass.call(void 0, [
    _chunkDSPWNYKZjs.validateURLSearchParams,
    _chunkDSPWNYKZjs.validateCsrf
], PcidAuth.prototype, "getQueryArgs", 1);
PcidAuth = exports.PcidAuth = _chunk3KNDPG6Yjs.__decorateClass.call(void 0, [
    _chunkDSPWNYKZjs.validateConfig
], PcidAuth);
exports.PcidAuth = PcidAuth;
